export default function GisValidationPanel() {
  const validations = [
    { label: "SRID definido", value: true, icon: "ri-focus-3-line" },
    { label: "Coordenadas válidas", value: true, icon: "ri-gps-line" },
    { label: "Geometria válida", value: true, icon: "ri-shape-2-line" },
    { label: "Área calculada", value: true, icon: "ri-ruler-line" },
    { label: "Centroide calculado", value: true, icon: "ri-compasses-2-line" },
    { label: "Camada pronta para exportação", value: true, icon: "ri-upload-cloud-2-line" },
  ];

  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4">Status de validação GIS</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {validations.map((v) => (
          <div key={v.label} className="flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200/70">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${v.value ? "bg-primary-100" : "bg-foreground-100"}`}>
              <i className={`${v.icon} ${v.value ? "text-primary-600" : "text-foreground-400"} text-lg`} />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground-900">{v.label}</p>
              <span className={`text-xs font-semibold ${v.value ? "text-primary-600" : "text-foreground-400"}`}>
                {v.value ? "Validado" : "Pendente"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}